import React, { useMemo, useState } from "react";
import { useNetwork } from "../../context/Dashboard/contextNetwork.js";
import { useDesign } from "../../context/contextDesign";

const ScanFromUUID = ({ embedded = false }) => {
  const {
    networkLoading,
    networkDashboardView,
    ipScanLoading,
    handleSubmit,
    handleNSubmit,
    setAgentUuid,
    scanType,
    setScanType,
    error,
  } = useNetwork();
  const { toggleUpgradeCard } = useDesign();
  const [uuid, setUuid] = useState("");
  const controlsDisabled =
    networkLoading || ipScanLoading || (!embedded && networkDashboardView);

  const uuidValid = useMemo(
    () =>
      /^[0-9a-fA-F]{8}-([0-9a-fA-F]{4}-){3}[0-9a-fA-F]{12}$/.test(
        uuid.trim()
      ),
    [uuid]
  );

  const onChangeUUID = (e) => {
    const value = e.target.value;
    setUuid(value);
    setAgentUuid(value);
  };

  const onSubmit =
    scanType === "private" || scanType === "public"
      ? handleSubmit
      : handleNSubmit;

  return (
    <div className="d-flex flex-column align-items-center py-4">
      <div className={embedded ? "text-center mb-3" : "text-center mb-4"}>
        {!embedded && <div className="fs-1 fw-bold">Add Completed Scan</div>}
        <div
          className="fs-6 fw-semibold text-muted mx-auto"
          style={{ maxWidth: 420 }}
        >
          The scanner runs locally. Copy its completed Scan ID here, then choose
          the same scan type to import and analyze the results.
        </div>
      </div>

      <form
        onSubmit={onSubmit}
        className="w-100 d-flex flex-column align-items-center p-4 rounded-4 shadow"
        style={{
          maxWidth: 560,
          background: "#ffffff",
          border: "1px solid #eaeaea",
        }}
      >
        <div className="d-flex flex-wrap justify-content-center gap-3 mb-4">
          <button
            type="button"
            className={`btn fw-semibold px-4 rounded-3 ${scanType === "private"
                ? "btn-primary shadow-sm"
                : "btn-outline-primary"
              }`}
            style={{ width: 140 }}
            onClick={() => setScanType("private")}
            disabled={controlsDisabled}
          >
            🔒 Private IP
          </button>

          <button
            type="button"
            className={`btn fw-semibold px-4 rounded-3 ${scanType === "public"
                ? "btn-success shadow-sm"
                : "btn-outline-success"
              }`}
            style={{ width: 140 }}
            onClick={() => setScanType("public")}
            disabled={controlsDisabled}
          >
            🌐 Public IP
          </button>

          <button
            type="button"
            className={`btn fw-semibold px-4 rounded-3 ${
              scanType === "network"
                ? "btn-success shadow-sm"
                : "btn-outline-success"
            }`}
            style={{ width: 160 }}
            onClick={() => setScanType("network")}
            disabled={controlsDisabled}
          >
            🖧 Network Scan
          </button>
        </div>

        <label htmlFor="scanUuid" className="fw-semibold mb-2">
          Scan ID
        </label>

        <div className="input-group mb-2" style={{ maxWidth: 420 }}>
          <input
            id="scanUuid"
            type="text"
            className={`form-control text-center ${!uuidValid && uuid.length > 0 ? "is-invalid" : ""
              }`}
            placeholder="12345678-1234-1234-1234-123456789012"
            value={uuid}
            onChange={onChangeUUID}
            disabled={controlsDisabled}
            autoComplete="off"
            spellCheck="false"
          />
        </div>

        <div className="text-muted mb-3" style={{ fontSize: 12 }}>
          Format: 8-4-4-4-12 hex (RFC-4122)
        </div>

        <div style={{ width: 260 }}>
          {error && (
            <div
              className="error-hover text-danger text-center fw-semibold mb-2"
              onClick={error.card ? toggleUpgradeCard : undefined}
              style={{ cursor: error.card ? "pointer" : "default" }}
            >
              {error.message || String(error)}
            </div>
          )}
        </div>

        <button
          type="submit"
          className="btn btn-success w-100 py-2 fw-semibold fs-6"
          disabled={
            controlsDisabled ||
            !uuidValid ||
            !scanType
          }
          title={
            !scanType
              ? "Select a scan type first"
              : !uuidValid
                ? "Enter a valid Scan ID"
                : undefined
          }
          style={{ maxWidth: 420, height: 46 }}
        >
          {ipScanLoading ? "Adding scan..." : "Add Scan to Dashboard"}
        </button>

        <div className="mt-3 small text-muted">
          Selected scan type:{" "}
          <span className="fw-semibold text-dark">
            {scanType || "—"}
          </span>
        </div>
      </form>
    </div>
  );
};

export default ScanFromUUID;
